<script setup>
import { WdsUsp } from '@wds/components';

defineProps({
  compactUsps: {
    type: Boolean,
    default: false,
  },
  scrollWithPage: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <section class="hw-sidebar">
    <div
      class="floating-sidebar new-header"
      :class="{ 'scroll-with-page': scrollWithPage }"
    >
      <div class="usps-wrapper">
        <WdsUsp
          :title="$t('t_CANCELFORFREE')"
          :text="$t('t_CANCELFORFREEDESCRIPTION')"
          icon="calendar-confirmation"
          size="md"
        />
        <WdsUsp
          v-if="!compactUsps"
          :title="$t('t_TRIEDANDTRUSTEDBYMILLIONSTITTLE')"
          :text="$t('t_TRIEDANDTRUSTEDBYMILLIONSDESCRIPTION')"
          icon="communication"
          size="md"
        />
        <WdsUsp
          v-if="!compactUsps"
          :title="$t('t_BEDSFORANYBUDGETTITLE')"
          :text="$t('t_BEDSFORANYBUDGETDESCRIPTION')"
          icon="globe"
          size="md"
        />
      </div>
      <slot />
    </div>
  </section>
</template>

<style lang="scss" scoped>
.hw-sidebar {
  display: block;
  position: relative;
  flex-basis: wds-rem(384px);

  .floating-sidebar {
    position: sticky;
    top: wds-rem(156px);
    margin-bottom: $wds-spacing-xxl;
    display: flex;
    flex-direction: column;
    gap: $wds-spacing-m;

    &.new-header {
      top: wds-rem(120px);
    }

    &.scroll-with-page {
      position: relative;
      top: auto;
    }
  }
}
</style>
